import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('PROCEDURE SERVICE');

@Injectable({
  providedIn: 'root'
})
export class ProcedureService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'procedures' como el nombre del recurso a la clase base
    super('procedures');
    log.debug('Servicio de Procedimientos inicializado');
  }

}